import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, Circle, Sparkles } from "lucide-react";
import { api } from "@/lib/api";

const STEPS = [
  ["marche", "Aggiungi la tua prima marca", "La marca è la dimensione principale delle analisi.", "/marche"],
  ["prodotti", "Aggiungi il tuo primo prodotto", "SKU, prezzo di vendita, costo e giacenza iniziale.", "/prodotti"],
  ["fornitori", "Aggiungi un fornitore", "Serve per registrare le fatture di acquisto.", "/fornitori"],
  ["fatture", "Registra la prima fattura d'acquisto", "Carica il PDF: l'AI estrae le righe e aggiorna il costo medio.", "/fatture/nuova"],
  ["movimenti", "Registra incassi e costi", "Oppure imposta le spese ricorrenti (affitto, software…).", "/movimenti"],
];

const count = (r) => (Array.isArray(r.data) ? r.data.length : r.data.items?.length || 0);

export function Onboarding() {
  const [done, setDone] = useState({});
  useEffect(() => {
    Promise.all(STEPS.map(([k]) => api.get(`/${k}`).then(count).catch(() => 0)))
      .then((ns) => setDone(Object.fromEntries(STEPS.map(([k], i) => [k, ns[i] > 0]))));
  }, []);
  const n = Object.values(done).filter(Boolean).length;
  return (
    <section className="card-soft p-6 sm:p-8 fade-up" data-testid="onboarding-card">
      <div className="flex items-center gap-2 overline-label !text-[#8C6D62]"><Sparkles className="h-3.5 w-3.5" />Primi passi · {n}/{STEPS.length}</div>
      <h2 className="text-2xl font-medium mt-2">Benvenuta in Cosmetica Control</h2>
      <p className="text-sm text-[#756B64] mt-1 max-w-2xl">L'app è pronta per i tuoi dati reali. Segui questi passaggi: dashboard, margini e magazzino si popoleranno automaticamente.</p>
      <ol className="mt-6 grid sm:grid-cols-2 lg:grid-cols-5 gap-3">
        {STEPS.map(([k, title, text, to], i) => (
          <li key={k}>
            <Link to={to} data-testid={`onboarding-step-${k}`} className={`block h-full rounded-2xl border p-4 transition-colors ${done[k] ? "border-[#8AA090]/40 bg-[#8AA090]/10" : "border-[#EAE3DC] bg-white hover:bg-[#F4EFEA]"}`}>
              <div className="flex items-center gap-2 text-xs text-[#756B64]">{done[k] ? <CheckCircle2 className="h-4 w-4 text-[#4E6656]" /> : <Circle className="h-4 w-4" />}Passo {i + 1}</div>
              <div className="font-semibold text-sm mt-2">{title}</div>
              <div className="text-xs text-[#756B64] mt-1">{text}</div>
            </Link>
          </li>
        ))}
      </ol>
    </section>
  );
}
